/* ==========================================================================
   BRANDSETS - obsluga galerii dla produktow z JEDNYM zdjeciem.

   Motyw buduje galerie produktu na dwa sposoby:
     - 2 zdjecia i wiecej  -> slider <swiper-product-gallery>, ktory sam
       uruchamia PhotoSwipe i modul Zoom (assets/product-media-gallery.js),
     - dokladnie 1 zdjecie -> statyczna SIATKA, bez elementu slidera.

   Przy siatce nie dzialalo ani jedno, ani drugie:
     1) klikniecie w zdjecie szlo zwyklym linkiem <a target="_blank">
        i otwieralo goly plik JPG w nowej karcie zamiast galerii,
     2) pinch dwoma palcami lapala przegladarka i powiekszala CALA STRONE,
        bo cale drzewo mialo touch-action: auto.

   Ten plik naprawia oba przypadki tak, zeby siatka zachowywala sie
   dokladnie jak slider. Zadna z funkcji nie rusza slidera - obie
   przerywaja, gdy w kontenerze galerii znajda <swiper-product-gallery>.
   ========================================================================== */

/* --------------------------------------------------------------------------
   1. LIGHTBOX (galeria po kliknieciu)

   Uruchamiamy dla siatki DOKLADNIE ten sam lightbox co dla slidera: te same
   ikony zamknij / wstecz / dalej, ta sama klasa motywu
   (pswp--product-media-gallery) i ta sama blokada przewijania strony.

   Bezpieczniki:
     - data-bs-lightbox pilnuje, zeby nie inicjowac dwa razy (edytor motywu
       przeladowuje sekcje),
     - gdy PhotoSwipe sie nie wczyta, po prostu nic nie robimy i zostaje
       stare zachowanie linku - nic sie nie psuje.
   -------------------------------------------------------------------------- */

function bsGridLightboxInit() {
  if (typeof PhotoSwipeLightbox === "undefined" || typeof PhotoSwipe === "undefined") return;

  const closeIcon = document.querySelector("[data-close-icon]");
  const prevIcon = document.querySelector("[data-prev-icon]");
  const nextIcon = document.querySelector("[data-next-icon]");

  function isPhone() {
    return window.innerWidth < 750;
  }

  document.querySelectorAll(".main-product__media").forEach(galleryEl => {
    if (galleryEl.querySelector("swiper-product-gallery")) return;
    if (!galleryEl.querySelector("a.product__gallery-toggle")) return;
    if (galleryEl.dataset.bsLightbox === "on") return;
    galleryEl.dataset.bsLightbox = "on";

    const lightbox = new PhotoSwipeLightbox({
      gallery: galleryEl,
      children: "a.product__gallery-toggle",
      mainClass: "pswp--product-media-gallery",

      loop: false,
      showHideAnimationType: "zoom",

      /* (v34) wspolne ustawienia z assets/product-media-gallery.js */
      ...(window.bsPswpOptions ? window.bsPswpOptions(() => lightbox) : {}),

      pswpModule: PhotoSwipe
    });

    lightbox.addFilter("uiElement", (element, data) => {
      if (data.name === "close" && closeIcon) {
        element.innerHTML = closeIcon.innerHTML;
      } else if (data.name === "arrowPrev" && prevIcon) {
        element.innerHTML = prevIcon.innerHTML;
      } else if (data.name === "arrowNext" && nextIcon) {
        element.innerHTML = nextIcon.innerHTML;
      }
      return element;
    });

    /* wideo i modele 3D podaja gotowy HTML w data-pswp-html */
    lightbox.addFilter("itemData", itemData => {
      if (itemData.type === "html" && itemData.element) {
        return { html: itemData.element.dataset.pswpHtml };
      }
      return itemData;
    });

    lightbox.init();

    /* klasa motywu blokujaca przewijanie strony - literowka "oveflow"
       jest w CSS motywu, wiec musi zostac */
    lightbox.on("beforeOpen", () => {
      document.body.classList.add("oveflow-hidden");
    });
    lightbox.on("closingAnimationStart", () => {
      document.body.classList.remove("oveflow-hidden");
    });
  });
}

/* --------------------------------------------------------------------------
   2. PINCH ZOOM
   -------------------------------------------------------------------------- */

/* Przyblizanie gestem (pinch) - odtworzenie zachowania slidera.

   Przy sliderze (2+ zdjec) robi to modul Zoom Swipera, a element .swiper ma
   touch-action: pan-y, wiec przegladarka nie powieksza calej strony.
   Przy jednym zdjeciu nie ma zadnego Swipera - cale drzewo ma touch-action
   auto, wiec pinch lapala przegladarka i powiekszala CALA STRONE zamiast
   samego zdjecia.

   Ponizej odtwarzamy zachowanie slidera:
     - pinch dwoma palcami skaluje zdjecie w miejscu (max 3x),
     - jednym palcem przesuwamy przyblizone zdjecie (z ograniczeniem do
       krawedzi, zeby nie dalo sie go "zgubic"),
     - pinch do srodka wraca do 1x,
     - zwykle tapniecie nadal otwiera lightbox, ale gest juz nie - inaczej
       po kazdym przyblizeniu wyskakiwalaby galeria.

   touch-action ustawiamy dynamicznie:
     pan-y  - stan spoczynku, palec w pionie normalnie przewija strone,
     none   - w trakcie gestu i gdy zdjecie jest przyblizone, bo wtedy
              jednym palcem przesuwamy zdjecie, a nie strone.
   ========================================================================== */

function bsGridPinchZoomInit() {
  document.querySelectorAll(".main-product__media").forEach(galleryEl => {
    if (galleryEl.querySelector("swiper-product-gallery")) return;
    if (galleryEl.dataset.bsPinch === "on") return;

    const media = galleryEl.querySelector(".media");
    const image = media && media.querySelector("img");
    if (!media || !image) return;
    galleryEl.dataset.bsPinch = "on";

    const MAX_SCALE = 3;
    const pointers = new Map();
    let scale = 1;
    let tx = 0;
    let ty = 0;
    let startDistance = 0;
    let startScale = 1;
    let startTx = 0;
    let startTy = 0;
    let panStart = null;
    let gestureHappened = false;

    media.style.overflow = "hidden";
    media.style.touchAction = "pan-y";
    image.style.transformOrigin = "center center";

    function applyTransform(animate) {
      image.style.transition = animate ? "transform 250ms ease" : "";
      image.style.transform =
        "translate3d(" + tx + "px, " + ty + "px, 0) scale(" + scale + ")";
      media.style.touchAction = scale > 1 ? "none" : "pan-y";
    }

    function clampOffset() {
      const box = media.getBoundingClientRect();
      const maxX = Math.max(0, (box.width * scale - box.width) / 2);
      const maxY = Math.max(0, (box.height * scale - box.height) / 2);
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    }

    function currentDistance() {
      const list = Array.from(pointers.values());
      return Math.hypot(list[0].x - list[1].x, list[0].y - list[1].y);
    }

    function resetZoom(animate) {
      scale = 1;
      tx = 0;
      ty = 0;
      applyTransform(animate);
    }

    media.addEventListener("pointerdown", event => {
      if (event.pointerType !== "touch") return;
      if (pointers.size === 0) gestureHappened = false;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (pointers.size === 2) {
        startDistance = currentDistance();
        startScale = scale;
        startTx = tx;
        startTy = ty;
        gestureHappened = true;
        media.style.touchAction = "none";
      } else if (pointers.size === 1 && scale > 1) {
        panStart = { x: event.clientX, y: event.clientY, tx: tx, ty: ty };
      }
    });

    media.addEventListener(
      "pointermove",
      event => {
        if (event.pointerType !== "touch" || !pointers.has(event.pointerId)) return;
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (pointers.size >= 2 && startDistance > 0) {
          event.preventDefault();
          const ratio = currentDistance() / startDistance;
          scale = Math.max(1, Math.min(MAX_SCALE, startScale * ratio));
          tx = startTx;
          ty = startTy;
          clampOffset();
          applyTransform(false);
          gestureHappened = true;
        } else if (panStart && scale > 1) {
          event.preventDefault();
          tx = panStart.tx + (event.clientX - panStart.x);
          ty = panStart.ty + (event.clientY - panStart.y);
          clampOffset();
          applyTransform(false);
          gestureHappened = true;
        }
      },
      { passive: false }
    );

    function releasePointer(event) {
      if (event.pointerType !== "touch") return;
      pointers.delete(event.pointerId);
      if (pointers.size < 2) startDistance = 0;

      if (pointers.size === 0) {
        panStart = null;
        /* (v34) przyblizenie palcami to tylko podglad - po puszczeniu wraca do 1x */
        resetZoom(true);
      } else if (pointers.size === 1 && scale > 1) {
        const remaining = Array.from(pointers.values())[0];
        panStart = { x: remaining.x, y: remaining.y, tx: tx, ty: ty };
      }
    }

    media.addEventListener("pointerup", releasePointer);
    media.addEventListener("pointercancel", releasePointer);

    /* Gest nie moze uchodzic za klikniecie. Czyste tapniecie przepuszczamy,
       ale najpierw kasujemy przyblizenie - inaczej lightbox otwieralby sie
       z animacja liczona ze zniekształconej miniatury. */
    media.addEventListener(
      "click",
      event => {
        if (gestureHappened) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (scale > 1) resetZoom(false);
      },
      true
    );
  });
}

/* --------------------------------------------------------------------------
   Start
   -------------------------------------------------------------------------- */

function bsProductMediaInit() {
  bsGridLightboxInit();
  bsGridPinchZoomInit();
}

if (typeof Shopify !== "undefined" && Shopify.designMode) {
  window.addEventListener("shopify:section:load", bsProductMediaInit);
}

if (document.readyState === "complete") {
  bsProductMediaInit();
} else {
  window.addEventListener("load", bsProductMediaInit);
}